<template>
	<div class="teaser-video">
        <div class="wrapper">
                <div class="wrapper-video">
                    <video class="video-case-film" controls poster="@/assets/Cover-Teaservideo.jpg" preload="none"
                           src="https://player.vimeo.com/external/330989794.hd.mp4?s=eb927644325841aca5cf5878cb1305ea0e3d5f4d&profile_id=175">
                    </video>

                    <div class="controls__video">
                        <div class="controls__video-inner">
                            <button id="play-pause" class="btn-play" title="Play/Pause video"><span><font-awesome-icon class="play-circle" icon="play-circle"></font-awesome-icon></span>Product Spot</button>
                        </div>

                        <div class="controls__video-outer">
                            <div id="vid-progress" class="progress">
                                <span class="progress-current" id="curr-progress"></span>
                            </div>
                            <div class="time">
                                <span class="current">00:00</span> /
                                <span class="duration">00:48</span>
                            </div>
                            <button class="btn-fullscreen" title="Switch to fullscreen view"><span>see it fullscreen</span></button>
                        </div>
                    </div>
                </div>
        </div>
	</div>
</template>

<script>


	export default {
        name: 'teaser-video',

		data() {
			return {
			}
		},
        mounted() {

            // DETECT TOUCH SUPPORT
            var isTouchCapable = 'ontouchstart' in window ||
                window.DocumentTouch && document instanceof window.DocumentTouch ||
                navigator.maxTouchPoints > 0 ||
                window.navigator.msMaxTouchPoints > 0;


            // DETECT MP4 SUPPORT
            var isMP4Capable = false;
            var v = document.createElement('video');
            if (v.canPlayType && v.canPlayType('video/mp4').replace(/no/, '')) {
                isMP4Capable = true;
            }

            if (isTouchCapable) {
                document.body.classList.add('touch-support');
            }

            if (isMP4Capable) {
                document.body.classList.add('mp4-support');
            }

            // CUSTOM HTML5 VIDEO

            if (isMP4Capable) {
                var video = document.getElementsByClassName('video-case-film');
                var controlbtn = document.getElementById('play-pause');

                video[0].removeAttribute("controls");


            var playpause = function () {

                if (video[0].paused || video[0].ended) {
                    controlbtn.classList.add('paused');
                    video[0].play();

                } else {
                    controlbtn.classList.remove('paused');
                    video[0].pause();
                }
            };


            if (isTouchCapable) {
                video[0].ontouchstart = function () {
                    playpause();
                };
                controlbtn.ontouchstart = function () {
                    playpause();
                };
            }
            else {
                video[0].onclick = function () {
                    playpause();
                };

                controlbtn.onclick = function () {
                    playpause();
                };
            }



            //video ended event
                video[0].onended = function () {
                    controlbtn.classList.add('paused');
                   video[0].pause();
             };

            //fullscreen button clicked change the controld
            var btnFullScreen  =  document.getElementsByClassName('btn-fullscreen');
                btnFullScreen[0].onclick = function () {
                if (typeof (video[0].webkitEnterFullscreen) === 'function') {
                    video[0].webkitEnterFullscreen();
                } else if (typeof (video[0].mozRequestFullScreen) === 'function') {
                    video[0].mozRequestFullScreen();
                } else {
                    alert('Your browsers doesn\'t support fullscreen');
                }
            };


            var progress = document.getElementById('vid-progress');
            var currProgress = document.getElementById('curr-progress');


            var updatebar = function (x) {

                var maxduration = video[0].duration;
                var position = x - progress.offsetLeft;
                var percentage = 100 * position / progress.offsetWidth;
                if (percentage > 100) {
                    percentage = 100;
                }
                if (percentage < 0) {
                    percentage = 0;
                }

                currProgress.style.width = percentage + '%';
                video[0].currentTime = maxduration * percentage / 100;
            };

                var timeDrag = false; /* check for drag event */
                progress.addEventListener('mousedown', function (e) {
                    timeDrag = true;
                    updatebar(e.pageX);
                });

                window.addEventListener('mouseup', function (e) {
                    if (timeDrag) {
                        timeDrag = false;
                        updatebar(e.pageX);
                    }
                });

                window.addEventListener('mousemove', function (e) {
                    if (timeDrag) {
                        updatebar(e.pageX);
                    }
                });

            var timeFormat = function (seconds) {
                var m = Math.floor(seconds / 60) < 10 ? "0" + Math.floor(seconds / 60) : Math.floor(seconds / 60);
                var s = Math.floor(seconds - (m * 60)) < 10 ? "0" + Math.floor(seconds - (m * 60)) : Math.floor(seconds - (m * 60));
                return m + ":" + s;
            };

            // display current video play time
            var curr = document.getElementsByClassName('current');
            var duration = document.getElementsByClassName('duration');

            video[0].ontimeupdate = function () {
                var currentPos = video[0].currentTime;
                var maxduration = video[0].duration;
                var perc = 100 * currentPos / maxduration;
                currProgress.style.width = perc + '%';
                curr[0].innerHTML = timeFormat(currentPos);
            };

            video[0].onloadedmetadata = function () {
                curr[0].innerHTML = timeFormat(0);
                duration[0].innerHTML = timeFormat(video[0].duration);
             };
        }
        else {
                document.getElementsByClassName('wrapper-video').appendChild('<iframe src="https://player.vimeo.com/video/330989794" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>');
              }

        },
		methods: {

		},
	}

</script>



<style lang="scss" scoped>

    .teaser-video {
        position: relative;
        width: 100%;
        margin: 0 auto;

    }

    .wrapper {
        margin: 0 auto;
        position: relative;
        max-width: 90vw;

        @media screen and (max-width: 768px) {
            max-width: 100vw;
        }
    }


    body:not(.mp4-support) .wrapper-video {
        padding-top: 56.25%;
    }

    .wrapper-video {
        position: relative;
    }

    video {
        width: 100%;
        outline:none;
    }

    iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: none;
    }

    body:not(.mp4-support) .controls__video,
    body:not(.mp4-support) video {
        display: none;
    }

    body:not(.touch-support) .btn-play:hover {
        transform: scale(1.2) translate(-40%,-40%);
    }


    .controls__video {
        &-inner {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            padding-top: 56.25%;
            pointer-events: none;
        }
    }



    .btn-play {
        opacity: 1;
        pointer-events: all;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        transition: opacity 0.3s, transform 0.3s;
        -moz-transition: opacity 0.3s, transform 0.3s;
        -webkit-transition: opacity 0.3s, transform 0.3s;
        -o-transition: opacity 0.3s, transform 0.3s;
        border: none;
        background: none;
        padding: 1% 5%;
        margin: 0;
        cursor: pointer;
        outline: none;
        -webkit-tap-highlight-color: rgba(0,0,0,0);
        -webkit-tap-highlight-color: transparent;
        padding: 1% 5%;
        background: #fff;
        text-transform: uppercase;
        font-family: dkms1;
        font-size: 2.7rem;
        color: #5D402F;
        display: block;

            @media screen and (max-width: 1024px) {
                font-size: 2rem;
            }

            @media screen and (max-width: 767px) {
                font-size: 1rem;
            }

            @media screen and (max-width: 560px) {
                font-size: .9rem;
            }

        svg {
            font-size: 2.5rem;
            right: 3%;
            position: relative;


            @media screen and (max-width: 1024px) {
                font-size: 1.8rem;

            }

            @media screen and (max-width: 767px) {
                font-size: .8rem;

            }

        }
    }


    .btn-fullscreen {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: flex-start;
        align-items: stretch;
        background-color: #999999;
        padding: 1% 5%;
        margin-top: 1.7%;
        cursor: pointer;
        outline: none;
        text-transform: uppercase;
        font-family: dkms1;
        font-size: .9rem;
        letter-spacing: 1px;
        color: #fff;
        border: 4px solid !important;
        border-color: transparent;
        &:hover {
            color: #999 !important;
            background: transparent;
            border: 4px solid #999 !important;
            transition: all 0.4s ease 0s;

        }
            @media screen and (min-width: 768px) {
                font-size: 1.4rem;
            }
    }

    .paused  {
        opacity: 0;
        pointer-events: none;
    }


    .progress {
        margin-top: 1%;
        width: 100%;
        height: 2px;
        position:relative;
        cursor:pointer;
        background: #DDD;
    }

    .progress span {
        height:100%;
        position:absolute;
        top:0;
        left:0;
        display:block;
    }

    .progress-current {
        z-index: 10;
        width: 0;
        background: #5D402F;
    }

    .time {
        margin-top: 1%;
        float: right;
        text-align: center;
        font-size: .8rem;

            @media screen and (max-width: 768px) {
                margin: 2%;
            }
    }

</style>
